import React, { useCallback } from 'react';

import ResponsiveModal from '../../modals';
import { Flex } from '../../modals/styles';
import { useModalProviderContext } from '../../ModalProvider';
import { confirmDeleteAttributeModal } from '../../ModalProvider/modalNames';

const ConfirmDeleteAttributeModal = () => {
  const {
    setIsOpen,
    extras: {
      displayName,
      onSubmit,
    },
  } = useModalProviderContext(confirmDeleteAttributeModal);

  const cancel = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <ResponsiveModal
      title={`Delete ${displayName}`}
      modalName={confirmDeleteAttributeModal}
      size="small"
    >
      <Flex direction="column" style={{ padding: '1em' }}>
        <span>Are you sure you want to delete {displayName}?</span>
        <Flex justify="space-between">
          <button className="btn btn-primary" onClick={onSubmit}>
          Confirm
          </button>
          <button className="btn" onClick={cancel}>
          Cancel
          </button>
        </Flex>
      </Flex>
    </ResponsiveModal>
  );
};
export default ConfirmDeleteAttributeModal;
